import React from "react";
import HeroComponent from "../components/Hero";
import ContactForm from "../components/ContactForm";
import useFadeIn from "../hooks/useFadeIn";
import "../styles/GlobalStyles.css";

const Home = () => {
  const refWelcome = useFadeIn();
  const refPhoto = useFadeIn();
  const refContact = useFadeIn();

  return (
    <>
      <HeroComponent />

      <main className="page-wrap">
        {/* Welcome */}
        <section
          ref={refWelcome}
          className="fade-up"
          style={{ marginBottom: "40px" }}
        >
          <h2 style={{ marginBottom: "14px" }}>
            Welcome to Afterglo Beautyco!
          </h2>
          <p style={{ color: "var(--mid)", maxWidth: "640px" }}>
            I'm so glad you're here! With over 7 years of experience, my passion
            is making you fall in love with lashes and the beauty industry.
            Whether you're a potential client or an aspiring lash artist, I'm
            here to support you every step of the way. I'm currently accepting
            new lash and brow clients, and welcoming students to my lash
            extension licensing course and lash mastery course.
          </p>
          <p style={{ color: "var(--mid)", marginTop: "10px" }}>
            Please don't hesitate to reach out. I'm here to help you every step
            of the way. Meet me in the afterglo!!!
          </p>
        </section>

        <hr className="divider" />

        {/* Photo */}
        <section
          ref={refPhoto}
          className="fade-up"
          style={{ marginBottom: "40px", textAlign: "center" }}
        >
          <img
            src="/courtglow.jpg"
            alt="Courtney"
            style={{
              width: "100%",
              maxWidth: "480px",
              margin: "0 auto",
              borderRadius: "var(--radius-lg, 20px)",
              boxShadow: "var(--shadow-lg)",
              objectFit: "cover"
            }}
          />
        </section>

        <hr className="divider" />

        {/* Contact form */}
        <section ref={refContact} className="fade-up">
          <span className="pill">Get in Touch</span>
          <ContactForm />
        </section>
      </main>
    </>
  );
};

export default Home;
